// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpSendMessage_closeButton__30tpu","rounded":"PopUpSendMessage_rounded__tvKpG"};